import DefaultAuthPort from "@/shared/auth/DefaultAuthPort";
import NclayerAuthPort from "@/shared/auth/NclayerAuthPort";

const defaultAuthPort = new DefaultAuthPort();
const nclayerAuthPort = new NclayerAuthPort();

export const authPort = {
  default: defaultAuthPort,
  nclayer: nclayerAuthPort,
};
